import styled from "styled-components";

const HomeMonthlyTrendWrapper = styled.div`
  margin-top: 40px;
  padding: 0 16px;

  .content-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .monthly-trend-content {
    width: 50%;
    margin-top: 8px;
    display: flex;
    flex-direction: column;

    li {
      cursor: pointer;
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 12px 4px;
      border-bottom: 1px solid #f1f3f5;

      .monthly-trend-content-rank {
        margin-right: 10px;
        font-size: 1.125rem;
        font-weight: bold;
        color: #ff7a00;
      }

      > span {
        p:first-child {
          font-size: 0.75rem;
          font-weight: regular;
          color: #4a5056;
        }

        p:last-child {
          font-size: 0.875rem;
          font-weight: medium;
          color: #222529;
        }
      }
    }
  }
`;

export { HomeMonthlyTrendWrapper };
